import CiiVoyageData from "./data";

export default function mapCiiVoyageDataFromJson(json) {
    return new CiiVoyageData(
        json['minDate'],
        json['maxDate'],
        json['ladenBallast'],
        json['voyNum'],
        json['voyLeg']
    )
}
